import Cookies from "js-cookie";
import EnvironmentService from "./environmentService";

export default class TaskService {

    constructor() {
        this.environmentService = new EnvironmentService();
    }

    async retrieveTasks(projectID) {
        const queryString = "?projectID=" + encodeURIComponent(projectID);

        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/Task" + queryString,
            {
                headers:
                {
                    "Authorization": "Bearer " + Cookies.get("access_token")
                }
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }
    }

    async createTask(projectUUID, taskTitle, taskDescription, taskType) {
        const queryString = "?projectUUID=" + encodeURIComponent(projectUUID);
        if (taskDescription === null) {
            taskDescription = "";
        }

        let taskObject = {
            TaskTitle: taskTitle,
            TaskDescription: taskDescription,
            TaskType: taskType
        }

        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/Task" + queryString,
            {
                headers:
                {
                    "Authorization": "Bearer " + Cookies.get("access_token"),
                    "Content-type": "application/json"

                },
                method: "POST",
                body: JSON.stringify(taskObject)

            });
        let data = {
            body: await result.json(),
            statuscode: result.status
        }
        return data;

    }

    async getTaskInDetail(taskUUID) {
        const queryString = "?taskUUID=" + encodeURIComponent(taskUUID);

        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/Task/Detail" + queryString,
            {
                headers:
                {
                    "Authorization": "Bearer " + Cookies.get("access_token")
                }
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }
    }

    async changeTaskStatus(taskUUID, newTaskStatus) {

        let taskUpdateObject = {
            taskUUID: taskUUID,
            taskStatus: newTaskStatus
        };

        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/Task",
            {
                headers:
                {
                    "Authorization": "Bearer " + Cookies.get("access_token"),
                    "Content-type": "application/json"
                },
                method: "PUT",
                body: JSON.stringify(taskUpdateObject)
            });

        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }
    }

    async getTasksByStatus(projectUUID, taskStatusID) {
        const queryString = "?projectUUID=" + encodeURIComponent(projectUUID) + "&projectStatusID=" + encodeURIComponent(taskStatusID);

        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/Task/Status" + queryString, {
            headers: {
                "Authorization": "Bearer " + Cookies.get("access_token")
            },
            method: "GET"
        });

        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }
    }

    async getTasksBySprint(sprintUUID) {
        const queryString = "?sprintUUID=" + encodeURIComponent(sprintUUID);

        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/Task/Sprint" + queryString, {
            headers: {
                "Authorization": "Bearer " + Cookies.get("access_token")
            },
            method: "GET"
        });

        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }
    }

    async getTasksInBacklog(projectUUID) {
        const queryString = "?projectUUID=" + encodeURIComponent(projectUUID);

        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/Task/Backlog" + queryString, {
            headers: {
                "Authorization": "Bearer " + Cookies.get("access_token")
            },
            method: "GET"
        });

        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }
    }
}


// WEBPACK FOOTER //
// ./src/service/taskService.js